export interface VText {
  text: string;
  type: VTextType[];
}

export enum VTextType {
  TEXT = "text",
  BOLD = "bold",
  ITALIC = "italic",
  UNDERLINE = "underline",
  H1 = "h1",
  H2 = "h2",
  H3 = "h3",
}
